import { useCallback } from "react";
import { stringify } from "query-string";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { useApi } from "../../../hooks/useApi";
import { urlReplacer } from "../../../utils";

export default function () {
  const { request } = useApi();

  return {
    fetchAll: useCallback(
      async (filter, userId, userRole) => {
        return request({
          method: "GET",
          url: `${urlReplacer(
            ApiRoutes.MANAGED_STUDENTS + stringify({ ...filter, userRole }),
            {
              id: userId,
            },
          )}`,
        });
      },
      [request],
    ),

    fetchStudentNames: useCallback(
      (userId, userRole) => {
        return request({
          method: "GET",
          url: `${urlReplacer(
            ApiRoutes.STUDENT_NAMES + "?" + stringify({ userRole }),
            { id: userId },
          )}`,
        });
      },
      [request],
    ),

    fetchStudentCountries: useCallback(
      (userId, userRole) => {
        return request({
          method: "GET",
          url: `${urlReplacer(
            ApiRoutes.STUDENT_COUNTRIES + "?" + stringify({ userRole }),
            { id: userId },
          )}`,
        });
      },
      [request],
    ),

    fetchStudentData: useCallback(
      (userId) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_USER, { id: userId })}`,
        });
      },
      [request],
    ),

    createStudent: useCallback(
      async (data) => {
        return request({
          data,
          method: "POST",
          url: ApiRoutes.CREATE_STUDENT,
        });
      },
      [request],
    ),

    getStudentDetails: useCallback(
      (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_STUDENT_DETAILS, { id })}`,
        });
      },
      [request],
    ),

    editStudent: useCallback(
      (data, id) => {
        return request({
          data,
          method: "PUT",
          url: `${urlReplacer(ApiRoutes.EDIT_STUDENT, { id })}`,
        });
      },
      [request],
    ),
  };
}
